<style scoped lang="scss">

@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (min-width: 300px) and (max-width:400px) {
  .profile-phone .el-carousel__button {
    background: #000 !important;
    height: 3px;
  }
  .banner {
    overflow: auto;
    width: 100% !important;
  }
  .wrap-home .profile-phone{
    background: #fff!important;
  }
  .wrap-home .news .news-lists li .time{
    border-right: none!important;
    display: table-cell;
  }
  .wrap-home .news .news-lists li .info{
    display: table-cell;
  }
  .banner1 {
    display: block !important;
  }
  .banner2 {
    display: none;
  }
  .service_top,.news_top{
    background: #fff!important;
  }
  .service_top .xing_1 li .img {
    padding-top: 35px !important;
    padding-bottom: 35px !important;
  }
  .service_top .xing_1 li .img img {
    width: 100%;
  }
  .ss3 {
    display: none;
  }
  .ss2 {
    display: none;
  }
  .wrap-home .news .news-lists li {
    display: block !important;
    overflow: auto;
  }
  .wrap-home .news .news-lists li .time {
    float: left;
    width: 35%;
  }
  .wrap-home .news .news-lists li .info {
    float: left;
    width: 60%;
    margin-left: 2%;
  }
  .container2 {
    width: 90% !important;
    margin: 0 auto;
    position: relative;
  }
  .service_top1 {
    display: block !important;
  }
  .service_top2 {
    display: none !important;
  }
  .c-title {
    font-size: 18px;
    padding: 10px 0;
  }
  .news_top {
    padding-bottom: 20px !important;
  }
  .c-title small {
    font-size: 16px;
  }
  .service_top .xing_1 li {
    margin-bottom: 10px;
    width: 330px !important;
    margin-right: 0 !important;
    height: 200px !important;
  }
  .service_top .xing_1 li .img {
    width: 70px !important;
  }
  .service_top .xing_1 li:last-child {
    margin-bottom: 0;
  }
  .service_top .xing_1 {
    display: block !important;
  }
  .container-phone {
    display: block !important;
  }
  .container-pc {
    display: none !important;
  }
  .ss1 {
    margin-bottom: 20px;
  }
  .profile-phone h2 {
    font-size: 14px;
    margin-bottom: 10px;
  }
  .profile-phone h2:last-child {
    margin-bottom: 0;
  }

}
@media screen and (max-width: 414px) and (min-width: 413px) {
  .banner {
    overflow: auto;
    width: 100% !important;
  }
  .wrap-home .profile-phone{
    background: #fff!important;
  }
  .wrap-home .news .news-lists li .time{
    border-right: none!important;
  }
  .banner1 {
    display: block !important;
  }
  .banner2 {
    display: none;
  }
  .service_top,.news_top{
    background: #fff!important;
  }
  .service_top .xing_1 li .img {
    padding-top: 35px !important;
    padding-bottom: 35px !important;
  }
  .service_top .xing_1 li .img img {
    width: 100%;
  }
  .ss3 {
    display: none;
  }
  .ss2 {
    display: none;
  }
  .wrap-home .news .news-lists li {
    display: block !important;
    overflow: auto;
  }
  .wrap-home .news .news-lists li .time {
    float: left;
    width: 35%;
  }
  .wrap-home .news .news-lists li .info {
    float: left;
    width: 60%;
    margin-left: 2%;
  }
  .container2 {
    width: 90% !important;
    margin: 0 auto;
    position: relative;
  }
  .service_top1 {
    display: block !important;
  }
  .service_top2 {
    display: none !important;
  }
  .c-title {
    font-size: 18px;
    padding: 10px 0;
  }
  .news_top {
    padding-bottom: 20px !important;
  }
  .c-title small {
    font-size: 16px;
  }
  .service_top .xing_1 li {
    margin-bottom: 10px;
    width: 330px !important;
    margin-right: 0 !important;
    height: 200px !important;
  }
  .service_top .xing_1 li .img {
    width: 70px !important;
  }
  .service_top .xing_1 li:last-child {
    margin-bottom: 0;
  }
  .service_top .xing_1 {
    display: block !important;
  }
  .container-phone {
    display: block !important;
  }
  .container-pc {
    display: none !important;
  }
  .ss1 {
    margin-bottom: 20px;
  }
  .profile-phone h2 {
    font-size: 14px;
    margin-bottom: 10px;
  }
  .profile-phone h2:last-child {
    margin-bottom: 0;
  }
}
@media screen and (max-width: 640px) and (min-width: 600px) {
  .banner {
    overflow: auto;
    width: 100% !important;
  }
  .service_chan li {
    margin-right: auto !important;
    margin-bottom: 10px;
    //width: 125px!important;
    height: auto!important;
    overflow: auto;
    background: #fff!important;
    float: left;
  }
  .wrap-home .profile-phone{
    background: #fff!important;
  }
  .wrap-home .news .news-lists li .time{
    border-right: none!important;
  }
  .wrap-home .news .news-lists li .title{
    font-size: 16px!important;
  }
  .wrap-home .news .news-lists li .time{
    font-size: 18px!important;
  }
  .banner1 {
    display: block !important;
  }
  .banner2 {
    display: none;
  }
  .service_top,.news_top{
    background: #fff!important;
  }
  .service_top .xing_1 li .img {
    padding-top: 35px !important;
    padding-bottom: 35px !important;
  }
  .service_top .xing_1 li .img img {
    width: 100%;
  }
  .ss3 {
    display: none;
  }
  .ss2 {
    display: none;
  }
  .wrap-home .news .news-lists li {
    display: block !important;
    overflow: auto;
  }
  .wrap-home .news .news-lists li .time {
    float: left;
    width: 35%;
  }
  .wrap-home .news .news-lists li .info {
    float: left;
    width: 60%;
    margin-left: 2%;
  }
  .container2 {
    width: 90% !important;
    margin: 0 auto;
    position: relative;
  }
  .service_top1 {
    display: block !important;
  }
  .service_top2 {
    display: none !important;
  }
  .c-title {
    font-size: 18px;
    padding: 10px 0;
  }
  .news_top {
    padding-bottom: 20px !important;
  }
  .c-title small {
    font-size: 16px;
  }
  .service_top .xing_1 li {
    width: 332px !important;
    height: 200px !important;
    margin-bottom: 20px;
  }
  .service_top .xing_1 li:last-child{
    margin-bottom: 0;
  }
  .service_top .xing_1 li p{
    font-size: 14px!important;
  }
  .service_top .xing_1 li .img {
    width: 70px !important;
  }
  .service_top .xing_1 li:last-child {
    margin-bottom: 0;
  }
  .service_top .xing_1 {
    display: block !important;
  }
  .container-phone {
    display: block !important;
  }
  .container-pc {
    display: none !important;
  }
  //.ss1 {
  //  margin-bottom: 20px;
  //}
  .profile-phone h2 {
    font-size: 14px;
    margin-bottom: 10px;
  }
  .profile-phone h2:last-child {
    margin-bottom: 0;
  }
}
.banner1 {
  display: none;
}

.container-phone {
  display: none;
}

.container-pc {
  display: block;
}

.service_top1 {
  display: none;
}

//业务范围
.service_top {
  width: 100%;
  overflow: auto;
  padding-bottom: 50px;
  background: url("../assets/img/yewu.jpg") no-repeat;
  background-size: 100% auto;

  .service2 {
    overflow: auto;
  }

  .xing_1 {
    display: flex;
    overflow: auto;
    width: -moz-fit-content;
    width: fit-content;
    margin-left: auto;
    margin-right: auto;

    li {
      height: 312px;
      width: 380px;
      margin-right: 30px;

      .img {
        width: 123px;
        padding-top: 43px;
        padding-bottom: 45px;
        margin-left: auto;
        margin-right: auto;
      }

      p {
        font-size: 20px;
        color: #fff;
        width: -moz-fit-content;
        width: fit-content;
        margin-left: auto;
        margin-right: auto;
      }
    }

    li:last-child {
      margin-right: 0;
    }

    .xingcheng {
      overflow: auto;
      background: url("../assets/img/gene.jpg") no-repeat;
      background-size: auto;
    }

    .xingcheng1 {
      overflow: auto;
      background: url("../assets/img/life.jpg") no-repeat;
      background-size: auto;
    }

    .xingcheng2 {
      overflow: auto;
      background: url("../assets/img/biology.jpg") no-repeat;
      background-size: auto;
    }

    //鼠标移入后
    .xingcheng:hover {
      overflow: auto;
      cursor: pointer;
      background: url("../assets/img/gene1.jpg") no-repeat;
      background-size: auto;
    }

    .xingcheng1:hover {
      overflow: auto;
      cursor: pointer;
      background: url("../assets/img/life1.jpg") no-repeat;
      background-size: auto;
    }

    .xingcheng2:hover {
      overflow: auto;
      cursor: pointer;
      background: url("../assets/img/biology1.jpg") no-repeat;
      background-size: auto;
    }
  }
}

//产品服务
.service1 {
  overflow: auto;
}

.service_chan {
  margin-bottom: 20px;
  display: flex;
  overflow: auto;
  flex-wrap: wrap;
  justify-content: space-between;

  li {
    width: 188px;
    height: 188px;
    //margin-right: 12px;
    background: url("../assets/img/fuwu.jpg") no-repeat!important;
    background-size: auto!important;
    .img{
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
      padding-top: 20px;
      padding-bottom: 20px;
    }

    p {
      font-size: 16px;
      color: #4e4e4e;
      margin-bottom: 10px;
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
    }

    .liaojie {
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
      color: #959595;
      cursor: pointer;
    }
  }
  li:hover{
    background: url("../assets/img/fuwu1.jpg") no-repeat!important;
    background-size: auto!important;
    p{
      color: #fff;
    }

    .liaojie {
      color: #fff;
    }
  }

  li:last-child {
    margin-right: 0;
  }
}

.service_chan1 {
  justify-content: center;
}

.service_chan1 li {
  margin-right: 40px;
}

.service_chan1 li:last-child {
  margin-right: 0;
}

//新闻中心
.news_top {
  width: 100%;
  overflow: auto;
  padding-bottom: 50px;
  background: url("../assets/img/news.jpg") no-repeat;
  background-size: 100% auto;
}

.container2 {
  width: 1200px;
  margin: 0 auto;
  position: relative;
}

//市场和活动
.container3 {
  width: 100%;
  cursor: pointer;
  padding-bottom: 10px;
  margin: 0 auto;
  position: relative;
}
.jiantou{
  text-align: center;
}

//擎科概况
.profile .left {
  width: 52%;
  float: left;
}

.profile h2 {
  font-size: 18px;
  line-height: 30px;
  color: #223759;
  margin-bottom: 10px;
}

.profile h2 span {
  margin-left: 20px;
  color: #223759;
}

.profile h2:last-child {
  margin-bottom: 0;
}

.profile .right1 {
  width: 45%;
  height: 440px;
  float: right;
}

.chakan {
  border: none;
  background: linear-gradient(top, #00c8d8, #0089db);
}

//公共
.container1 {
  width: 100% !important;
}

@media screen and (min-width: 768px) {
  .wrap-home {
    section {
      //padding-top:120px;
      .con {
        padding-top: 40px;
      }
    }

    .service {
      .lists {
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;

        li {
          width: 200px;
          height: 200px;
          text-align: center;
          font-size: 16px;
          margin: 0 60px 20px;
          border-radius: 8px;
          cursor: pointer;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          img {
            margin-top: -15px;
          }

          &.active {
            background: #014492;
            color: #fff;
          }
        }
      }
    }
  }
  .market {
    padding: 0;

    .container {
      width: 1000px;
    }

    .container-phone {
      display: none;
    }

    .info {
      padding: 80px 0;

      p {
        margin: 25px 0 50px;
      }
    }
  }
  .news {
    .con-phone {
      display: none;
    }

    .right li {
      border-bottom: 1px dashed #cccecf;

      .time {
        text-align: -webkit-center !important;
        border-right: none !important;
        padding: 5px 0px 5px 0 !important;

        small {
          padding-top: 10px;
          border-top: 2px solid #223759;
          width: 60px;
        }
      }
    }

    .news-right {
      color: #223759;

      .text-ellipsis2 {
        color: #b2b3b4;
      }
    }

    .news-left {
      border-image: linear-gradient(top, #00c8d8, #0089db);
      border: 5px solid #00add9;

      .news-info {
        overflow: auto;
        background: #fff !important;
        height: 81px;
        margin-top: -3px;

        .title {
          font-size: 18px;
          padding-top: 10px;
          padding-bottom: 5px;
          padding-left: 10px;
          font-weight: bold;
        }

        .time {
          text-align: -webkit-center !important;
          border-right: none !important;
          padding: 5px 0px 5px 0 !important;
          width: 100px !important;
          color: #6c6c6c;

          small {
            font-size: 16px;
          }
        }

        .info {
          color: #000;
        }
      }
    }

    .news-lists {
      li {
        display: flex;
        align-items: center;
        margin-bottom: 28px;
        padding: 0 10px;
        cursor: pointer;
        height: 130px;

        &:last-child {
          margin-bottom: 0;
        }

        .time {
          width: 90px;
          font-size: 28px;
          font-weight: bold;
          text-align: right;
          border-right: 1px solid #eee;
          padding: 5px 15px 5px 0;
          margin-right: 15px;

          small {
            font-size: 16px;
            font-weight: normal;
            display: block;
          }
        }

        .info {
          flex: 1;
          min-width: 0;
        }

        .title {
          font-size: 20px;
          font-weight: 500;
          margin-bottom: 10px;
        }
      }

      &.right {
        li {
          &:hover {
            background: rgba(209, 228, 247, .2);

            .title {
              color: #014492;
            }

            //.time{
            //  border-right:1px solid #014492;
            //}
          }
        }
      }
    }

    .news-info {
      //position: absolute;
      z-index: 3;
      //bottom:0;
      color: #fff;
      width: 100%;
      //left:0;
    }

    .news-left {
      cursor: pointer;
      height: 100%;

      .news-info {
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.4) 100%);
        padding-bottom: 10px;
      }
    }
  }
  .profile {
    //background: #F6FAFD;
    margin-bottom: -130px;
    position: relative;
    z-index: 2;

    .profile-img {
      width: 100%;
      display: block;
      font-size: 0;
    }

    .quotation {
      width: 37px;
      margin-bottom: 30px;
    }

    .info {
      padding: 0  40px 40px  40px;
    }

    p {
      font-size: 18px;
      line-height: 1.5;
      margin-bottom: 30px;
    }
  }
  .profile-phone {
    display: none;
  }
}

@media screen and (max-width: 768px) {
  .wrap-home {
    width: 100%;

    .container {
      width: 100%;

      .c-title {
        font-size: 20px;
        padding: 20px;
        text-align: center;

        small {
          font-size: 15px;
        }
      }
    }

    .service {
      .lists {
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        width: 100%;

        li {
          flex: 30%;
          // height:30px;
          text-align: center;
          font-size: 12px;
          // margin: 0 10px 10px;
          border-radius: 8px;
          cursor: pointer;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          img {
            // margin-top: -15px;
            width: 60%;
            text-align: center;
          }

          &.active {
            background: #014492;
            color: #fff;
          }
        }
      }
    }

    .market {
      padding: 0;

      .container {
        display: none;
      }

      .container-phone {
        width: 100%;

        .carousel-content {
          // margin: 0 auto;
          width: 100%;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
      }

      .info {
        padding: 20px 0;
        text-align: center;

        p {
          margin: 10px 0 10px;
          font-size: 12px;
        }
      }
    }

    .news {
      .con {
        display: none;
      }

      .news-lists {
        li {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          padding: 0 10px;
          cursor: pointer;
          // height:118px;
          &:last-child {
            margin-bottom: 0;
          }

          .time {
            flex: 0.15;
            // width:90px;
            font-size: 16px;
            font-weight: bold;
            text-align: right;
            border-right: 1px solid #eee;
            padding: 3px 3px 3px 0;
            margin-right: 5px;

            small {
              font-size: 14px;
              font-weight: normal;
              display: block;
            }
          }

          .info {
            flex: 0.85;
            min-width: 0;
          }

          .title {
            font-size: 16px;
            font-weight: 500;
            margin-bottom: 10px;
          }
        }

        &.right {
          li {
            &:hover {
              background: rgba(209, 228, 247, .2);

              .title {
                color: #014492;
              }

              .time {
                border-right: 1px solid #014492;
              }
            }
          }
        }
      }

      .news-info {
        position: absolute;
        z-index: 3;
        bottom: 0;
        color: #fff;
        width: 100%;
        left: 0;
      }

      .news-left {
        cursor: pointer;
        height: 100%;

        .news-info {
          background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.4) 100%);
          padding-bottom: 10px;
        }
      }
    }

    .profile {
      display: none;
    }

    .profile-phone {
      background: #F6FAFD;
      margin-bottom: -130px;
      position: relative;
      z-index: 2;

      .profile-img {
        width: 100%;
        display: block;
        font-size: 0;
      }

      .quotation {
        width: 20px;
        margin-bottom: 10px;
      }

      .info {
        padding: 10px 10px;

        p {
          font-size: 14px;
        }
      }

      p {
        font-size: 14px;
        line-height: 2;
        margin-bottom: 10px;
      }
    }
  }
}

</style>
<style scoped>
@import url("../assets/service.css");
</style>
<style>
.banner .el-carousel__container img {
  height: 100%;
}

/* @media screen and  (min-width: 641px) {
  .banner .el-carousel__container {
    height: 878px !important;
  }
} */

@media screen and (max-width: 640px) and (min-width: 600px) {
  .container-phone .el-carousel__container {
    height: 245px !important;
  }

  .banner .el-carousel__button {
    background: #000 !important;
    width: 10px !important;
    height: 10px !important;
    border-radius: 50%;
  }
}
@media screen and (max-width: 414px) and (min-width: 413px) {
  .container-phone .el-carousel__container {
    height: 155px !important;
  }

  .banner .el-carousel__button {
    background: #000 !important;
    width: 10px !important;
    height: 10px !important;
    border-radius: 50%;
  }
}
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (min-width: 300px) and (max-width:400px) {
  .container-phone .el-carousel__container {
    height: 143px !important;
  }

  .banner .el-carousel__button {
    background: #000 !important;
    width: 10px !important;
    height: 10px !important;
    border-radius: 50%;
  }
}

@media screen and (max-width: 1440px) and (min-width: 1400px) {
  .container3 .el-carousel__container {
    height: 538px !important;
  }

  /* .banner .el-carousel__container {
    height: 697px !important;
  } */
}

@media screen and (max-width: 1366px) and (min-width: 1360px) {
  .container3 .el-carousel__container {
    height: 500px !important;
  }

  /* .banner .el-carousel__container {
    height: 565px !important;
  } */
}

@media screen and (max-width: 1280px) and (min-width: 1270px) {
  .container3 .el-carousel__container {
    height: 475px !important;
  }

  /* .banner .el-carousel__container {
    height: 820px !important;
  } */
}

/*@media screen and (max-height: 800px){*/
/*  .banner .el-carousel__container{*/
/*    height: 597px!important;*/
/*  }*/
/*}*/
@media screen and (max-width: 1680px) and (min-width: 1670px) {
  .container3 .el-carousel__container {
    height: 628px !important;
  }

  /* .banner .el-carousel__container {
    height: 847px !important;
  } */
}

@media screen and (max-width: 1600px) and (min-width: 1580px) {
  .container3 .el-carousel__container {
    height: 597px !important;
  }

  /* .banner .el-carousel__container {
    height: 820px !important;
  } */
}
</style>
<template>
  <div class="wrap wrap-home">
    <div class="banner banner2 con">
      <el-carousel :interval="5000" :height="bannerHeight">
        <el-carousel-item v-for="item in bannerLists" :key="item.id" >
          <img :src="item.img.visitedUrl"  width="100%" class="img-fluid" :class="{pointer: item.clickTriggerAction !== 'NONE'}" @click="toCarouselLink(item)" :alt="item.imgDescribe">
        </el-carousel-item>
      </el-carousel>
    </div>
    <!--移动端开始-->
    <div class="banner banner1 cons">
      <el-carousel :interval="5000" arrow="never" :height="bannerHeight">
        <el-carousel-item v-for="item in bannerLists" :key="item.id" >
          <img :src="item.img.visitedUrl" width="100%" class="img-fluid" :class="{pointer: item.clickTriggerAction !== 'NONE'}" @click="toCarouselLink(item)" :alt="item.imgDescribe">
        </el-carousel-item>
      </el-carousel>
    </div>
    <!--移动端结束-->
    <div class="container1">
      <div class=" service_top2 service_top">
        <div class="container2">
          <div class="service service2">
            <div class="c-title">业务范围<small>Business Scope</small></div>
            <ul class="xing_1">
              <li class="xingcheng" @mouseover="gene3">
                <a href="/products/Products1" target="_blank">
                  <div class="img"><img src="@/assets/img/gene.png" width="100%" alt="擎科生物-合成基因组学产品及服务"></div>
                  <p>合成基因组学产品及服务</p>
                </a>
              </li>
              <li class="xingcheng1" @mouseover="life3">
                <a href="/equipment/life_sciences" target="_blank">
                  <div class="img"><img src="@/assets/img/life.png" width="100%" alt="擎科生物-生命科学研究设备及原料"></div>
                  <p>生命科学研究设备及原料</p>
                </a>
              </li>
              <li class="xingcheng2">
                <a href="/Biological_manufacturing/Biological" target="_blank">
                  <div class="img"><img src="@/assets/img/biology.png" width="100%" alt="擎科生物-生物制造CXO"></div>
                  <p>生物制造CXO</p>
                </a>
              </li>
            </ul>
          </div>
          <div class="service service1">
            <div class="c-title">产品及服务<small>Service and Products</small></div>
            <!--合成基因组学产品及服务-->
            <ul class="service_chan" v-show="gene">
              <li style="cursor: pointer" v-for="(item, index) in gene1" :key="index"
                  :class="{active: currentService === index}" @mouseover="currentService = index"
                  @mouseout="currentService = -1" @click="$router.push(item.ref)">
                <div class="img">
                  <img :src="`/static/img/fenzi_${index+1}${currentService === index ? '' : '_active'}.png`">
                </div>
                <p>{{ item.name }}</p>
                <div class="liaojie">了解更多></div>
              </li>
            </ul>
            <!--生命科学研究设备及原料-->
            <ul class="service_chan service_chan1" v-show="life">
              <li style="cursor: pointer" v-for="(item, index) in life1" :key="index"
                  :class="{active: currentService === index}" @mouseover="currentService = index"
                  @mouseout="currentService = -1" @click="$router.push(item.ref)">
                <div class="img">
                  <img :src="`/static/img/life_${index+1}${currentService === index ? '' : '_active'}.png`" :style="{maxWidth: '64px'}">
                </div>
                <p :style="{paddingLeft: '10px',paddingRight: '10px'}">{{ item.name }}</p>
                <div class="liaojie">了解更多></div>
              </li>
            </ul>
            <div class="jiantou"><a href="#market"><i class="el-icon-arrow-down" style="font-size: 24px"></i></a></div>
          </div>
        </div>
      </div>
      <!--移动端开始-->
      <div class="service_top1 service_top" style="padding-bottom: 0!important;">
        <div class="container2">
          <div class="service service2">
            <div class="c-title">业务范围<small>Business Scope</small></div>
            <ul class="xing_1">
              <li class="xingcheng" @click="$router.push('/products/Products1')">
                <a target="_blank">
                  <div class="img"><img src="@/assets/img/gene.png" width="100%" alt="擎科生物-合成基因组学产品及服务"></div>
                  <p>合成基因组学产品及服务</p>
                </a>
              </li>
              <li class="xingcheng1" @click="$router.push('/equipment/life_sciences')">
                <a target="_blank">
                  <div class="img"><img src="@/assets/img/life.png" width="100%" alt="擎科生物-生命科学研究设备及原料"></div>
                  <p>生命科学研究设备及原料</p>
                </a>
              </li>
              <li class="xingcheng2" @click="$router.push('/Biological_manufacturing/Biological')">
                <a target="_blank">
                  <div class="img"><img src="@/assets/img/biology.png" width="100%" alt="擎科生物-生物制造CXO"></div>
                  <p>生物制造CXO</p>
                </a>
              </li>
            </ul>
          </div>
          <div class="service service1">
            <div class="c-title">产品及服务<small>Service and Products</small></div>
            <!--合成基因组学产品及服务-->
            <div class="ss1">
              <ul class="service_chan">
                <li style="cursor: pointer" v-for="(item, index) in gene1" :key="item.name"
                    :class="{active: currentService === index}" @click="$router.push(item.ref)">
                  <div class="img">
                    <img :src="`/static/img/fenzi_${index+1}${currentService === index ? '' : '_active'}.png`" style="width: 50px;height: 55px;">
                  </div>
                  <p>{{ item.name }}</p>
                  <div class="liaojie" @click="$router.push(item.ref)">了解更多></div>
                </li>
                <li style="cursor: pointer" v-for="(item, index) in life1" :key="item.name"
                    :class="{active: currentService === index}" @click="$router.push(item.ref)">
                  <div class="img">
                    <img :src="`/static/img/life_${index+1}${currentService === index ? '' : '_active'}.png`" style="width: 50px;height: 55px;">
                  </div>
                  <p>{{ item.name }}</p>
                  <div class="liaojie" @click="$router.push(item.ref)">了解更多></div>
                </li>
              </ul>
            </div>
            <!--生命科学研究设备及原料-->
<!--            <div class="ss">-->
<!--              <ul class="service_chan service_chan1">-->
<!--                <li style="cursor: pointer" v-for="(item, index) in life1" :key="index"-->
<!--                    :class="{active: currentService === index}" @click="$router.push(item.ref)">-->
<!--                  <div class="img">-->
<!--                    <img :src="`/static/img/life_${index+1}${currentService === index ? '' : '_active'}.png`">-->
<!--                  </div>-->
<!--                  <p>{{ item.name }}</p>-->
<!--                  <div class="liaojie" @click="$router.push(item.ref)">了解更多></div>-->
<!--                </li>-->
<!--              </ul>-->
<!--            </div>-->
            <!--移动端结束-->
          </div>
        </div>
      </div>
      <div class="market" id="market">
        <div class="c-title">市场和活动<small>Markets and events</small></div>
        <div class="container-pc">
          <div class="container1 container3">
            <!--          <img src="@/assets/img/market.jpg" width="100%"  class="img-fluid" >-->
            <el-carousel indicator-position="outside" arrow="never" height="725px">
              <el-carousel-item v-for="item in marketLists" :key="item.id">
                <el-row :gutter="90">
                  <!--                <el-col :span="12">-->
                  <!--                  <div class="info">-->
                  <!--                    <div class="fz20 text-primary fb">{{item.name}}</div>-->
                  <!--                    <p>{{item.content}}</p>-->
                  <!--                    <el-button type="primary" @click="toCarouselLink(item)" v-show="item.clickTriggerAction !== 'NONE'">了解更多</el-button>-->
                  <!--                  </div>-->
                  <!--                </el-col>-->
                  <el-col>
                    <div class="img-box tr" @click="toCarouselLink(item)">
                      <img :src="item.img.visitedUrl" class="img-fluid" :alt="item.imgDescribe">
                    </div>
                  </el-col>
                </el-row>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="jiantou"><a href="#news"><i class="el-icon-arrow-down" style="font-size: 24px"></i></a></div>
        </div>
        <!--市场和活动 适配移动端 -->
        <div class="container-phone">
          <el-carousel indicator-position="outside" arrow="never" class="container-phone_img">
            <el-carousel-item v-for="item in marketLists" :key="item.id">
              <el-row :gutter="90">
                <el-col :span="24">
                  <div class="img-box tr" style="max-height:300px;overflow:hidden" @click="toCarouselLink(item)">
                    <img :src="item.img.visitedUrl" width="100%" mode="widthFix">
                  </div>
                </el-col>
              </el-row>
            </el-carousel-item>
          </el-carousel>
        </div>
        <!--市场和活动 适配移动端 -->
      </div>
      <div class="news" id="news">
        <div class="news_top">
          <div class="container2">
            <div class="c-title">新闻资讯<small>News</small></div>
            <div class="con">
              <el-row :gutter="30">
                <el-col :span="12">
                  <el-carousel :interval="5000" :autoplay="newsAutoPlay" ref="newsCarousel" arrow="never" height="450px" style="background: #aaa;">
                    <el-carousel-item v-for="item in newsLists" :key="item.id">
                      <!--<img src="@/assets/images/news_1.png" class="img-fluid">-->
                      <div class="news-left" @click="toNewsDetails(item.id)">
                        <div class="img" style="height: 362px;"><img :src="item.cover.visitedUrl" class="img-fluid" style="height: 100%;" :alt="item.imgDescribe"></div>
                        <!--<div class="img"><img src="@/assets/img/new1.jpg"  width="100%"></div>-->
                        <div class="news-lists news-info">
                          <div class="info">
                            <div class="title text-ellipsis">{{ item.name }}</div>
                            <div class="time">
                              <small>{{ item.year }}-{{ item.month }}-{{ item.date }}</small>
                            </div>
                          </div>
                          <!--<div class="info">-->
                          <!--<div class="title text-ellipsis">{{item.name}}</div>-->
                          <!--<p class="text-ellipsis2">{{item.summary}}</p>-->
                          <!--</div>-->
                        </div>
                      </div>
                    </el-carousel-item>
                  </el-carousel>
                </el-col>
                <el-col :span="12">
                  <ul class="news-lists right news-right">
                    <li v-for="(item, index) in newsLists" :key="item.id" @click="toNewsDetails(item.id)"
                        @mouseover="showCurrentNews(index)" @mouseleave="newsAutoPlay = true">
                      <div class="time">
                        {{ item.date }}<small>{{ item.year }}-{{ item.month }}</small>
                      </div>
                      <div class="info">
                        <div class="title text-ellipsis">{{ item.name }}</div>
                        <p class="text-ellipsis2">{{ item.summary }}</p>
                      </div>
                    </li>
                  </ul>
                </el-col>
              </el-row>
              <div class="tc mt30" style="padding-bottom: 20px;margin-top: 50px!important;">
                <el-button class="chakan" type="primary" @click="$router.push('/news')">查看更多</el-button>
              </div>
              <div class="jiantou"><a href="#summary"><i class="el-icon-arrow-down" style="font-size: 24px"></i></a>
              </div>
            </div>
            <!-- 新闻资讯-移动端适配 -->
            <div class="con-phone">
              <!--<el-row>-->
              <!--<el-col :span="24">-->
              <!--<el-carousel :interval="5000" :autoplay="newsAutoPlay" ref="newsCarousel" arrow="never" height="310px"-->
              <!--style="background: #aaa;">-->
              <!--<el-carousel-item v-for="item in newsLists" :key="item.id">-->
              <!--&lt;!&ndash;<img src="@/assets/images/news_1.png" class="img-fluid">&ndash;&gt;-->
              <!--<div class="news-left" @click="toNewsDetails(item.id)">-->
              <!--<img :src="item.cover.visitedUrl" class="img-fluid" style="height:100%;">-->
              <!--&lt;!&ndash; <div class="news-lists news-info">-->
              <!--<li>-->
              <!--<div class="time">-->
              <!--{{item.date}}<small>{{item.year}}-{{item.month}}</small>-->
              <!--</div>-->
              <!--<div class="info">-->
              <!--<div class="title text-ellipsis">{{item.name}}</div>-->
              <!--<p class="text-ellipsis2">{{item.summary}}</p>-->
              <!--</div>-->
              <!-- </li>-->
              <!--</div> &ndash;&gt;-->
              <!--</div>-->
              <!--</el-carousel-item>-->
              <!--</el-carousel>-->
              <!--</el-col>-->
              <!--</el-row>-->
              <el-row>
                <el-col :span="24">
                  <ul class="news-lists right">
                    <li v-for="(item, index) in newsLists" :key="item.id" @click="toNewsDetails(item.id)"
                        @mouseover="showCurrentNews(index)" @mouseleave="newsAutoPlay = true">
                      <div class="time" style="font-size:16px">
<!--                        {{ item.date }}<small>{{ item.year }}-{{ item.month }}</small>-->
                        <img :src="item.cover.visitedUrl" class="img-fluid">
                      </div>
<!--                      <div class="img"><img :src="item.cover.visitedUrl" class="img-fluid"></div>-->
                      <div class="info">
                        <div class="title text-ellipsis" style="font-size: 14px">{{ item.name }}</div>
                        <!--<p class="text-ellipsis2" style="font-size:14px">{{ item.summary }}</p>-->
                      </div>
                    </li>
                  </ul>
                </el-col>
              </el-row>
              <div class="tc mt10">
                <el-button type="primary" size="mini" @click="$router.push('/news')">了解更多</el-button>
              </div>
            </div>
            <!-- 新闻资讯-移动端适配 -->
          </div>
        </div>
      </div>
      <div class="summary" style="overflow:auto;" id="summary">
        <div class="container2">
          <div class="c-title">擎科概况<small>About us</small></div>
          <div class="profile">
            <div class="left">
              <div class="info">
                <p class="desc">北京擎科生物科技股份有限公司（Beijing Tsingke Biotech Co., Ltd.）是一家自主全产业链的基因合成平台型企业，业务范围涵盖合成基因组学产品及服务、生命科学原料及设备、生物制造CXO三大方向。 </p>
                <!-- <p class="desc">企业总部位于北京，运营实体和实验室遍布全国，总运营面积超 70,000 m²。 业务覆盖中国并延伸至美国、德国等多个海外国家，为全球超过 20 万用户提供 服务与产品。截至2023年1月，公司现有员工1,200余名。擎科现有授权及在申专利共194项，其中发明专利91项，基因合成系列设备专利约90项。使用擎科生物服务和产品发表的文章数量累计超过6,818篇，影响因子累计达到29,393.2037。</p> -->
                <p class="desc">企业总部位于北京，运营实体和实验室遍布全国，总运营面积超70,000 m²。致力于为全球从事生命科学研究的科研人员及企事业单位提供高质量的生物技术服务和产品，业务覆盖全国并延伸至美洲、欧洲等海外地区，拥有快速响应客户需求的能力，为全球近20万用户提供服务与产品。</p>
                <h2>[使命]<span>生物科技 · 让世界更美好</span></h2>
                <h2>[愿景]<span>世界伟大的基因工厂</span></h2>
                <h2>[核心价值观]<span>品质 创新 奋斗 共赢</span></h2>
                <div class="tc" style="margin-top: 50px;">
                  <el-button type="primary" class="chakan" @click="$router.push('/summary/about')">查看更多</el-button>
                </div>
              </div>
            </div>
            <div class="right1">
              <el-carousel height="480px" arrow="never">
                <el-carousel-item v-for="(item, idx) in imgLists" :key="'imgShow'+idx">
                  <img :src="item.img" class="profile-img" :alt="item.alt" height="430px">
                </el-carousel-item>
              </el-carousel>
            </div>
            <!--<el-row :gutter="50">-->
            <!--<el-col :span="14">-->
            <!--<div class="info">-->
            <!--<img src="@/assets/images/quit.png" class="quotation">-->
            <!--<p>擎科生物（Tsingke Biotechnology Co., Ltd.）是一家合成生物学国家级高新科技企业，从事合成基因组学与生物合成产品的研究及开发。业务范围涵盖合成基因组学产品及服务、生命科学研究设备及原料、生物制造CXO三大方向。</p>-->
            <!--<p>公司运营实体和实验室遍布全国，业务覆盖中国并延伸至美国、德国等多个海外国家，已为全球约12万用户提供服务与产品。截至2023年1月，公司现有员工1,200余名。擎科现有授权及在申专利共194项，其中发明专利91项，基因合成系列设备专利约90项。使用擎科生物服务和产品发表的文章数量累计超过6,818篇，影响因子累计达到29,393.2037。</p>-->
            <!--<div class="tc"><el-button type="primary" @click="$router.push('/summary/about')">查看详情</el-button></div>-->
            <!--</div>-->
            <!--</el-col>-->
            <!--<el-col :span="10">-->
            <!--<img src="@/assets/images/profile_1.png" class="profile-img">-->
            <!--</el-col>-->
            <!--</el-row>-->
          </div>
          <!-- 擎科概况 -移动端适配 -->
          <div class="profile-phone">
            <el-row>
              <el-col :span="24">
                <el-carousel  arrow="never">
                  <el-carousel-item v-for="(item, idx) in imgLists" :key="'showImag'+idx">
                    <img :src="item.img" class="profile-img" :alt="item.alt">
                  </el-carousel-item>
                </el-carousel>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <!--<div class="info">-->
                <!--<img src="@/assets/images/quit.png" class="quotation" width="100%">-->
                <!--<p>北京擎科生物科技股份有限公司（Tsingke Biotechnology Co.,-->
                <!--Ltd.）是一家合成生物学国家高新技术企业，从事合成基因组学与生物合成产品的研究及开发。业务范围涵盖合成基因组学产品及服务、生命科学研究设备及原料、生物制造CXO三大方向。</p>-->
                <!--<p>-->
                <!--公司总部位于北京，运营实体和实验室遍布全国，业务覆盖中国并延伸至美国、德国等多个海外国家，为全球约12万用户提供服务与产品。截至2023年1月，公司现有员工1,200余名。擎科现有授权及在申专利共194项，其中发明专利91项，基因合成系列设备专利约90项。使用擎科生物服务和产品发表的文章数量累计超过6,818篇，影响因子累计达到29,393.2037。</p>-->
                <!--<div class="tc">-->
                <!--<el-button type="primary" size="mini" @click="$router.push('/summary/about')">查看详情</el-button>-->
                <!--</div>-->
                <!--</div>-->
                <div class="info">
                  <p class="desc">北京擎科生物科技股份有限公司（Tsingke Biotechnology Co., Ltd.）是一家自主全产业链的基因合成平台型企业，业务范围涵盖合成基因组学产品及服务、生命科学原料及设备、生物制造CXO三大方向。</p>
                  <!-- <p class="desc">企业总部位于北京，运营实体和实验室遍布全国，总运营面积超 70,000 m²。 业务覆盖中国并延伸至美国、德国等多个海外国家，为全球超过 20 万用户提供 服务与产品。截至2023年1月，公司现有员工1,200余名。擎科现有授权及在申专利共194项，其中发明专利91项，基因合成系列设备专利约90项。使用擎科生物服务和产品发表的文章数量累计超过6,818篇，影响因子累计达到29,393.2037。</p> -->
                  <p class="desc">企业总部位于北京，运营实体和实验室遍布全国，总运营面积超70,000 m²。致力于为全球从事生命科学研究的科研人员及企事业单位提供高质量的生物技术服务和产品，业务覆盖全国并延伸至美洲、欧洲等海外地区，拥有快速响应客户需求的能力，为全球近20万用户提供服务与产品。</p>
                  <h2>[使命]<span>生物科技 · 让世界更美好</span></h2>
                  <h2>[愿景]<span>世界伟大的基因工厂</span></h2>
                  <h2>[核心价值观]<span>品质 创新 奋斗 共赢</span></h2>
                  <div class="tc" style="margin-top: 50px;">
                    <el-button type="primary" size="mini" class="chakan" @click="$router.push('/summary/about')">查看更多
                    </el-button>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <!-- 擎科概况 -移动端适配 -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {homePageCarousels, marketCarousels, newsColumns, newsInformation} from '@/services/api.index';

export default {
  inject: ['reload'],
  data() {
    return {
      activeName: 'first',
      life: false,
      gene: true,
      gene1: [
        {name: '引物合成', ref: '/tec/compose1'},
        {name: '基因合成', ref: '/tec/gen_compose'},
        {name: '基因功能', ref: '/products/Gene_regulation'},
        {name: '病毒包装', ref: '/Virus/Virus_packaging'},
        {name: '常规分子项目', ref: '/products/Conventional_molecular_project'},
        {name: '基因检测', ref: '/products/Gene'}
      ],
      life1: [
        {name: '修饰合成', ref: '/equipment/Modified_synthesis'},
        {name: '仪器设备', ref: '/equipment/Instruments_equipment'},
        {name: '分子试剂', ref: '/equipment/Molecular_reagent'},
        {name: '化学试剂', ref: '/equipment/Chemical_Reagents'},
        {name: '合成原料/设备/工艺 一站式解决方案', ref: '/equipment/IntegratedScheme'},
      ],
      currentService: -1,
      bannerLists: [],
      marketLists: [],
      newsLists: [],
      imgLists: [
        {
          img:require('../assets/img/index/1.jpg'),
          alt:'擎科生物-合成生物学国家高新技术企业，从事合成基因组学与生物合成产品的研究及开发。业务范围涵盖合成基因组学产品及服务、生命科学研究设备及原料、生物制造CXO三大方向。'
        },
        {
          img:require('../assets/img/index/2.jpg'),
          alt:'擎科生物-合成生物学国家高新技术企业，从事合成基因组学与生物合成产品的研究及开发。业务范围涵盖合成基因组学产品及服务、生命科学研究设备及原料、生物制造CXO三大方向。'
        },
        {
          img:require('../assets/img/index/3.jpg'),
          alt:'擎科生物-合成生物学国家高新技术企业，从事合成基因组学与生物合成产品的研究及开发。业务范围涵盖合成基因组学产品及服务、生命科学研究设备及原料、生物制造CXO三大方向。'
        }
      ],
      newsAutoPlay: true,
      bannerHeight: '',
      bannerH: 300,
    }
  },
  created () {
    this.reload()
    this.getBanners()
    this.getMarket()
    this.getNewsTabs()
  },
  beforeMount() {
    this.bannerHeight = document.body.clientWidth * 665 / 1440 + 'px'
    
    // this.bannerHeight = 850 + 'px'
  },
  mounted() {
    // this.setBannerH()
    window.addEventListener('resize', () => {
      this.setBannerH()
    }, false)
  },
  methods: {
    setBannerH() {
      this.bannerHeight = document.body.clientWidth * 665 / 1440 + 'px'
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    gene3() {
      this.gene = true;
      this.life = false;
    },
    life3() {
      this.gene = false;
      this.life = true;
    },
    // 获取banner
    getBanners() {
      homePageCarousels().then(res => {
        this.bannerLists = res.data
      })
    },
    // banner轮播图事件
    toCarouselLink(item) {
      this.baseMethods.carouselsAction(item)
    },
    // 市场和活动
    getMarket() {
      marketCarousels().then(res => {
        this.marketLists = res.data
      })
    },
    // 获取新闻栏目
    getNewsTabs() {
      newsColumns().then(res => {
        this.getNews(res.data[0].id)
      })
    },
    // 获取新闻列表
    getNews(id) {
      newsInformation(id, this.page, 3).then(res => {
        res.data.map(item => {
          item.year = this.baseMethods.formatDate(item.createTime)[0]
          item.month = this.baseMethods.formatDate(item.createTime)[1]
          item.date = this.baseMethods.formatDate(item.createTime)[2]
        })
        this.newsLists = res.data
      })
    },
    // 显示当前鼠标划过的新闻
    showCurrentNews(index) {
      this.$refs.newsCarousel.setActiveItem(index)
      this.newsAutoPlay = false
    },
    // 跳转到新闻详情页
    toNewsDetails(id) {
      this.$router.push(`/news/details/${id}`)
    }
  }
}
</script>
<style>
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (max-width: 400px) and (min-width: 300px)
{
  .profile-phone .el-carousel__button {
    background: #000 !important;
    height: 3px;
  }
}
@media screen and (min-width: 768px) {
  .container2 .el-carousel__button {
    background: #000 !important;
    height: 3px;
  }
  .container2 .el-carousel__indicators--horizontal {
    bottom: 10px !important;
  }

  .banner .el-carousel__button {
    background: #000 !important;
    width: 10px !important;
    height: 10px !important;
    border-radius: 50%;
  }

  .el-carousel__arrow--left, .el-carousel__arrow--right, .el-carousel__arrow:hover {
    background: none !important;
  }

  .banner .el-icon-arrow-left:before {
    font-size: 50px;
  }

  .banner .el-icon-arrow-right:before {
    font-size: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue